import { usePathname, useSearchParams } from 'next/navigation'

export const usePageLink = (key: string) => {
  const searchParams = useSearchParams()
  const path = usePathname()
  const generateLink = (page: number) => {
    const newSearchParams = new URLSearchParams(searchParams.toString())
    newSearchParams.set(key, page.toString())
    return `${path}?${newSearchParams.toString()}`
  }
  return generateLink
}
